<template >

  <div v-show="inputObj.display">
    <div class="row">
    <div class="col-12 col-md-2">
      <div
        v-if="inputModel.is_send"
        class="text-success text-center"
      >
        <i class="bi bi-envelope-check display-1"></i>

        <div class=" w-100 mt-1">
          {{inputObj.templates.email_send_info}}
        </div>
      </div>
      <div
          v-else
          class="text-danger text-center"
      >
        <i class="bi bi-envelope-x display-1"></i>

        <div class=" w-100 mt-1">
          {{inputObj.templates.email_not_send_info}}
        </div>
      </div>
    </div>
    <div class="col-12 col-md-10">
      <div
          v-if="inputObj.templates.is_switch"
          class="form-check form-switch mb-2"
      >
        <input
            v-model="inputModel.is_send"
            id="is_send"
            type="checkbox"
            placeholder="vypln text"
            class="form-check-input"
            value="1"
        >
        <label
            :for="'is_send'"
            class="form-check-label"
        >
          {{$t('email.client.is_send')}}
        </label>
      </div>


      <template
          v-if="inputModel.is_send"
      >
<!--
      <input
        v-model="inputModel.subject"
        type="text"
        class="form-control"
        placeholder="Predmet"
      />
        -->
      <textarea
          v-model="inputModel.body"
          :required="this.inputObj.required"
          class="form-control"
          @focus="is_locked=true;"
          :maxlength="(inputObj.params && inputObj.params.maxlength)? inputObj.params.maxlength : false"
          :placeholder="$t('email.client.body_placeholder')"
      >
      </textarea>
      </template>

    </div>
  </div>
  </div>

  <!--
  <display-debug>
    <template #debugView>inputModel {{inputObj}}</template>
  </display-debug>

  <display-debug>
    <template #debugView>inputModel {{inputModel}}</template>
  </display-debug>
  -->

</template>

<script>
import axios from "axios";

let timer;
let timerModel;
export default {
  name: "EmailInfoInput",
  props: {
    "inputObj": Object,
    "formObj": Object,
    "modelValue":  {
      type: [String, Object],
      required: false,
      default: null,
    },
    "activeLang": {
      type: [String],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      inputModel: null,
      is_locked: false,
      timer: null,
      timer_delay: 700,
    }
  },
  mounted() {
    //console.log('dev textare anotace', this.formObj.general.inputs.segment.val)
    if(this.inputObj.val != '' && this.inputObj.val != null ) {
      this.is_locked = true;
    }
    this.inputModel = this.inputObj.val;
  },
  methods: {
    async createAnotationFromSegment(segment){
      axios.defaults.baseURL = this.getBaseRoot();
      let apiPath = this.getApiConfig('obsah.create_anotation.path')// this.cfg.api.obsah.create_anotation.path;
      let formData = new FormData;
      //formData.append(this.cfg.api.obsah.create_anotation.input.segment, JSON.stringify(segment))
      formData.append(this.getApiConfig('obsah.create_anotation.input.segment'), JSON.stringify(segment))
      axios({
        url: apiPath,
        method: this.getApiConfig('obsah.create_anotation.method'),
        data: formData,
        withCredentials: true,
        headers: this.getRequestHeader(),
      }).then((res) => {
        if(res.data.status && res.data.response.anotace){
          if (this.inputObj.params.maxlength &&  res.data.response.anotace.length > this.inputObj.params.maxlength) {
            this.inputModel = res.data.response.anotace.substring(0, this.inputObj.params.maxlength) + "..."
          } else {
            this.inputModel = res.data.response.anotace;
          }
        }
      })
      .catch((err) => {
        //console.log("DEV createAnotationFromSegment ERR ", err);
      })
    }
  },
  watch: {
    "inputObj.params": {
      handler(newVal, odlVal) {
        //console.log('dev emailInfo watch inputObj.params', newVal)
        //this.inputModel = this.inputObj.val;
        if(
            newVal
            && typeof newVal.is_send != "undefined"
        ) {
          this.inputModel.is_send = true;
        }
      },
      deep: true,
      immediate: true
    },

    inputObj: {
      handler(newVal, odlVal) {
        //console.log('dev emailInfo watch inputObj', newVal.val)
        this.inputModel = this.inputObj.val;
      },
      deep: true,
      immediate: true
    },
    inputModel( newVal){
      //console.log('dev emailInfo watch inputModel', newVal)
      if(newVal == null || newVal == '') {
        //this.is_locked = false;
      }

    },
  },
};
</script>